import { Box } from '@fhs-legacy/universal-components';

export const LoadingContainer = Box.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '$48',
  width: 'full',
});
